export const CONTACT_TYPE_DEFAULT = 1;
